import React, {useState, useMemo, useEffect} from "react";
import RecentlyViewedContext from "./RecentlyViewedContext";

const RecentlyViewedState = (props) => {
  const [state, setState] = useState(() => {
    try {
      const items = JSON.parse(localStorage.getItem("recentlyViewed"));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  });

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );

  useEffect(() => {
    try {
      localStorage.setItem("recentlyViewed", JSON.stringify(state || []));
    } catch (e) {
      console.error("Error saving recentlyViewed to localStorage:", e);
    }
  }, [state]);

  return (
    <RecentlyViewedContext.Provider value={value}>
      {props.children}
    </RecentlyViewedContext.Provider>
  );
};

export default RecentlyViewedState;
